import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairTransferGuideContent } from "../../PairTransferGuideContent";

export default function TransferYoutubeToTidal() {
    return (
        <GuidesPage
            seoData={seoContent.transferYoutubeToTidal}
            sections={<PairTransferGuideContent sourceKey="youtube" destKey="tidal" />}
        />
    );
}
